<div class="verifying-email-container">
  <div class="content">
    <img src="assets/mascot/Mascot_runing-email@2x.webp" alt="odaring mascot" />
    <h1 class="heading-13" style="text-align: center">
      {{'verifying.your.email' | translate}}
    </h1>
  </div>
</div>
